import { SelectOption } from '@/types/form.type.ts';
import { ReportMaxYear, ReportMinYear } from '@/types/report.type.ts';

import { range } from '@/utils/collection-helpers.ts';
import { monthNames } from '@/utils/DateTimeFormatter.ts';

function getBrandSelectOptions(): SelectOption[] {
    return [
        { label: 'Hyundai', value: 1 },
        { label: 'Genesis', value: 2 },
    ];
}

function getReportYearOptions(): SelectOption[] {
    return range(ReportMaxYear, ReportMinYear, -1).map((year: number) => ({
        label: year,
        value: year,
    }));
}

function getReportMonthOptions(year?: number): SelectOption[] {
    const now = new Date();
    const months = year === undefined || year === now.getFullYear()
        ? monthNames.slice(0, now.getMonth())
        : [...monthNames];

    return months.map((month: string, index: number) => ({
        label: month,
        value: index + 1,
    }));
}

export {
    getBrandSelectOptions,
    getReportYearOptions,
    getReportMonthOptions,
};
